// Content for SB 1.1.1 fourth explanation, part 4

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 1.1.1',
        sloka: `oṁ namo bhagavate vāsudevāya
janmādy asya yato 'nvayād itarataś cārtheṣv abhijñaḥ svarāṭ
tene brahma hṛdā ya ādi-kavaye muhyanti yat sūrayaḥ |
tejo-vāri-mṛdāṁ yathā vinimayo yatra tri-sargo 'mṛṣā
dhāmnā svena sadā nirasta-kuhakaṁ satyaṁ paraṁ dhīmahi ||`,
        translation: `Let us meditate upon the Absolute Truth, Kṛṣṇa (<strong>satyaṁ paraṁ dhīmahi</strong>), who is the cause of creation, maintenance and destruction of this universe (<strong>janmādy asya yataḥ</strong>), as the material and efficient cause (<strong>anvayād itarataś ca</strong>), since he is the only knower of all objects (<strong>artheṣv abhijñaḥ</strong>) and the only independent being (<strong>svarāṭ</strong>); who revealed the Vedas to Brahmā within his mind (<strong>tene brahma hṛdā ya ādi-kavaye</strong>); who is difficult to understand even for the learned (<strong>muhyanti yat sūrayaḥ</strong>); whose body is thought to be made of matter due to illusion just as one mistakes fire, water and earth for each other (<strong>tejo-vāri-mṛdāṁ yathā vinimayo yatra tri-sargo ’mṛṣā</strong>); and who negates all false arguments regarding his existence by possessing a transcendental, inconceivable form, and by the strength of devotees’ experiencing him though his svarūpa-śakti (<strong>dhāmnā svena sadā nirasta-kuhakaṁ</strong>).`,
    },
    blocks: [
        {
            type: 'heading',
            headingText: 'Fourth explanation',
            content:
                'Without deceit, in correct manner, aspiring for the highest goal, <strong>we meditate on Rādhā and Kṛṣṇa from whom arises the height of madhura-rasa.</strong><br /><br />By giving up the other gopīs and following only her, as dhīra-lalita <strong>he showed his expertise in the chief aspects of rasa and she exhibited herself as an independent lover.</strong><br /><br />Kṛṣṇa imparted through the heart to Śukadeva, knower of this rasa from birth, the Bhāgavatam, <strong>by which the devotees faint in ecstasy and undergo transformation, just as fire, water and earth reverse their properties</strong><br /><br />and by whose influence the three śaktis remain eternally.',
        },
        {
            type: 'text',
            content:
                'Among all the gopīs, the peak of sweetness arises in the company of the queen of Vṛndāvana, the principal gopī. This is indicated in the following verses:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 10.30.27',
                sloka: `kasyāḥ padāni caitāni
yātāyā nanda-sūnunā
aṁsa-nyasta-prakoṣṭhāyāḥ
kareṇoḥ kariṇā yathā`,
                translation:
                    'Here we see the footprints of some gopī who must have been walking along with the son of Nanda Mahārāja. He must have put his arm on her shoulder, just as an elephant rests his trunk on the shoulder of an accompanying she-elephant.',
            },
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 10.30.28',
                sloka: `anayārādhito nūnaṁ
bhagavān harir īśvaraḥ
yan no vihāya govindaḥ
prīto yām anayad rahaḥ`,
                translation:
                    'Certainly this particular gopī has perfectly worshiped the all-powerful Personality of Godhead, Govinda, since he was so pleased withhHer that he abandoned the rest of us and brought her to a secluded place.',
            },
        },
        {
            type: 'text',
            content: 'A meaning which indicates this should be found in the first verse of Bhāgavatam.',
        },
        {
            type: 'text',
            content:
                'We meditate upon the Rādhā and Kṛṣṇa from whom there is the <strong>appearance (<em>janma</em>) of madhura-rasa (<em>ādyasya</em>)</strong>. This means that these two are the supreme receptacle of the art of madhura-rasa.',
        },
        {
            type: 'text',
            content:
                '<strong>Giving up all other gopī lovers (<em>itarataḥ</em>), he followed her alone and became obedient to her (<em>anvayāt</em>).</strong><br /><br /><em>Itarataḥ</em> has an ablative meaning (from others) and indicates a suppressed indeclinable participle. The following verse shows how he followed only Rādhā.',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 10.30.31-32',
                sloka: `atrāvaropitā kāntā
puṣpa-hetor mahātmanā
atra prasūnāvacayaḥ
priyārthe preyasā kṛtaḥ`,
                translation:
                    'And over here that intelligent boy must have put her down to gather some flowers. Just see how in this place dear Kṛṣṇa collected flowers for his beloved.',
            },
        },
        {
            type: 'text',
            content:
                'Because he gave up other gopīs and followed her alone, he is known as dhīra-lalita lover, favorable for cultivating rasa. <strong>He is thus called “one who is fully knowledgeable of the chief rasas filled with madhura-rasa (<em>artheṣu abhijñaḥ</em>).”</strong><br /><br />And because he is dhīra-lalita, <strong>she alone remains with her lover (<em>svarāṭ</em>), as a svādhīna-kāntā</strong>, a woman who controls Kṛṣṇa.',
        },
        {
            type: 'heading',
            headingText: 'Bhāgavatam Given to Śukadeva',
            content:
                'In order to reveal all this, <strong>he imparted through the heart the Bhāgavatam (<em>brahma</em>) containing as its essence the five chapters on rasa to Śukadeva, knower of this tattva (<em>kavaye</em>) from his birth (<em>ādi</em>).</strong><br /><br />The Bhāgavatam is called brahma in the following verse. idaṁ bhāgavataṁ nāma purāṇaṁ brahma-sammitam: this Bhāgavata Purāṇa is furnished with brahman. (SB 1.3.40) śuka-mukād amṛta-drava-saṁyutam: Bhāgavatam is sweetness flowing from the mouth of Śuka. (SB 1.1.3) Śuka-vāg-amṛtābdhīnduḥ: Kṛṣṇa is the moon rising from the sweet ocean of words of Śuka. (Kṛṣṇa-astottara-śata-nāma-stora, Brahmāṇḍa Purāṇa)',
        },
        {
            type: 'text',
            content:
                '<strong>From hearing the Bhāgavatam (<em>yad</em>) since it has rasa, the devotees faint in ecstasy from tasting the rasa (<em>yad sūrayaḥ muhyanti</em>).</strong> Or because Rādhā and Kṛṣṇa are the objects of their hearing and seeing, their close associates (<em>sūrayaḥ</em>), though most wise, become bewildered. This means that they take on qualities opposite their normal qualities, out of ecstasy. And others are included in this ecstasy also.<br /><br />This is illustrated through an example. Their ecstasy is just like earth, water and fire reversing their properties. <strong>For instance the moon, a form of fire, on seeing the rāsa-līlā of Rādhā and Kṛṣṇa, gave up its quality of moving and became stunned like earth. Water, on hearing the sound of the flute, became stunned like earth. Stones made of earth because liquid like water.</strong>',
        },
        {
            type: 'text',
            content:
                'By the influence of these two (<em>yatra dhāmnā svena</em>) the creation of the three consorts (<em>tri-sargaḥ</em>) Śrī, Bhū and Līlā; or the gopīs, the queens and Lakṣmīs; or the internal, external and marginal potencies becomes factual (<em>amṛsā</em>). This means that the consorts such as Śrī who have been manifested by Rādhā and Kṛṣṇa, by their influence, by their being the basis of the consorts, exist eternally because of their eternal relationship.<br /><br />We meditate on them without deceit, as in real forms (<em>satyam</em>) and as the most excellent forms (<em>param</em>). <strong>Thus the object of worship (Rādhā and Kṛṣṇa, viṣaya) of the Bhāgavatam has been shown as the subject of the first verse.</strong>',
        },
    ],
};

export default content;
